export const iconFontAwesomeChildhoodMitten = (
	<i className="fa-solid fa-mitten"></i>
);
